const PUSH_NOTIFICATION_PROMPT_SHOWN_COOKIE = 'push_notification_prompt_shown';

const THIRTY_DAYS_IN_SECONDS = 30 * 24 * 60 * 60;

export const isPushPromptShownCookieSet = (): boolean =>
  document.cookie
    .split('; ')
    .some((entry) => entry.startsWith(`${PUSH_NOTIFICATION_PROMPT_SHOWN_COOKIE}=`));

export const setPushPromptShownCookie = (): void => {
  document.cookie = `${PUSH_NOTIFICATION_PROMPT_SHOWN_COOKIE}=true; max-age=${THIRTY_DAYS_IN_SECONDS}; path=/; samesite=lax`;
};
